// @flow
import { type State } from 'app/common/ui-components/filter';

import { classActivity as classActivityDefault } from 'app/components/common/reports/filters/class';
import { flags as year } from 'app/components/common/reports/filters/year';
import { flags as customerType } from 'app/components/common/reports/filters/customerType';

import { flags as period } from './period';


const classActivity = (state: State) => {
  if (
    period.filterActive(state)
    && period.finalDateInPreviosMonthOrBefore(state)
  ) {
    return false;
  }

  return (
    classActivityDefault(state)
    && year.filterActive(state)
    && year.singleYearSelected(state)
    && customerType.filterActive(state)
    && customerType.onlyStudentCustomerSelected(state)
  );
};

export default classActivity;
